import(/* webpackMode: "eager" */ "/woodpecker/src/github.com/wisflux/school-erp/packages/frontend/src/app/(auth)/login/page.tsx");
